import { colors } from '../../../../../shared/colors';
import ODropDownMenu from '../../../UI/DropDownMenu/ODropDownMenu';
import { useTranslation } from 'react-i18next';

const GridOptionsPonude = ({ children, handleOpenDialog, downloadFile }) => {
  const { t, i18n } = useTranslation();
  const idFirme = localStorage.getItem('idFirme');

  const options = [
    {
      title: 'Obriši ponudu',
      subtitle: 'Obrišite izabranu ponudu',
      path: 'login',
      id: 2,
      icon: 'fas fa-trash',
      color: '#ff5552',
      onClick: () => handleOpenDialog(),
    },
    // {
    //   title: i18n.t('downloadDocupent'),
    //   subtitle: i18n.t('downloadDocupent'),
    //   id: 3,
    //   icon: 'fas fa-file-download',
    //   color: colors.EDIT,
    //   onClick: () => downloadFile(),
    // },
  ];

  const filteredOptions =
    idFirme === '1' ? options : options.filter((option) => option.id !== 2);

  // Use filteredOptions instead of options
  console.log(filteredOptions);

  return (
    <ODropDownMenu align="end" position="anchor" options={filteredOptions}>
      {children}
    </ODropDownMenu>
  );
};

export default GridOptionsPonude;
